import { getCommonError } from "./mergeCommonErrors";
import { IFetchError } from "./fetch";
import parseJSON from "./parseJSON";
import _isObject from "lodash/isObject";

type ErrorsVariations = {
  message?: string,
  error?: Record<string, string | string[]>
  errors?: Record<string, string | string[]>
  [key: string]: any,
} | string;

type ResponseError = IFetchError<ErrorsVariations> | Error | string | ErrorsVariations;

const UNKNOWN_ERROR_MESSAGE = 'Неизвестная ошибка';
const UNKNOWN_ERROR = { common: UNKNOWN_ERROR_MESSAGE };

const getErrorVariation = (error: ErrorsVariations): Record<string, string | string[]> => {
  if (!error) return UNKNOWN_ERROR;
  if (typeof error === 'string') return { common: error };
  if (error.errors) return _isObject(error.errors) ? error.errors : { common: error.errors };
  if (error.message) return { common: error.message };
  if (error.error) return _isObject(error.error) ? error.error : { common: error.error };
  if (error.detail) return { common: error.detail };
  if (_isObject(error)) return error;
  return UNKNOWN_ERROR;
}

const flatterErrorVariation = (errors: Record<string, string | string[]>) => {
  for (let key in errors) {
    let error = errors[key];
    errors[key] = typeof error === 'string'
      ? error
      : error.toString
        ? error.toString()
        : UNKNOWN_ERROR_MESSAGE;
  }
  if (errors?.common === 'access_denied') errors.common = 'Недостаточно прав';
  return errors as Record<string, string>;
}

const findError = (responseError: ResponseError): Record<string, string | string[]> => {
  if (!responseError) return UNKNOWN_ERROR;
  if (typeof responseError === 'string') return { common: responseError };
  if (responseError instanceof IFetchError) return getErrorVariation(responseError.error);
  if (responseError instanceof Error) return { common: responseError.message };
  if (typeof responseError !== 'object') return UNKNOWN_ERROR;
  return getErrorVariation(responseError);
}

const extractHttpError = (responseError: ResponseError) => {
  throw getHttpError(responseError);
}
export default extractHttpError;

export const getHttpError = (responseError: ResponseError): Record<string, string> => {
  return flatterErrorVariation(findError(responseError));
}

export const getBlobError = (error: IFetchError<Blob>) => new Promise<ReturnType<typeof getHttpError>>((res, rej) => {
  const fileReader = new FileReader();
  fileReader.onload = (event) => {
    const errorJson = parseJSON(event.target.result as string);
    res(errorJson);
  };
  fileReader.onerror = rej;
  fileReader.readAsText(error.error);
});

export const getCommonHttpError = (responseError: ResponseError): string => getCommonError(getHttpError(responseError));